/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import KoddiAPI from 'api';
import { takeEvery, call, all, put } from 'redux-saga/effects';
import SagaRegistry from 'redux-core/sagaRegistry';
import {
    fetchEntityAttributesSuccess,
    fetchEntityAttributesError,
} from './actions';

import { EntityAttributesAction, FetchEntityAttributesAction } from './types';

export function* fetchEntityAttributesSaga(
    action: FetchEntityAttributesAction
): Generator<any, void, any> {
    try {
        /* @ts-ignore */
        const response = yield call(
            KoddiAPI.Entities.getEntityAttributes,
            action.payload.memberGroupId
        );
        yield put(fetchEntityAttributesSuccess(response));
    } catch (e) {
        const error = e as { error?: { message?: string } };
        yield put(
            fetchEntityAttributesError(error.error?.message || 'Unknown error')
        );
    }
}

export function* watchConfig() {
    yield takeEvery(
        EntityAttributesAction.FETCH_ENTITY_ATTRIBUTES,
        fetchEntityAttributesSaga
    );
}

function* configSagas() {
    yield all([watchConfig()]);
}

SagaRegistry.registerSaga(configSagas);
